import React from 'react';
import { Modal, Button, Form, Input, Icon, Tabs, Switch, Divider } from 'antd';

import FormaPagoEfectivo from './FormModal/FormaPagoEfectivo';
import FormaPagoCredito from './FormModal/FormaPagoCredito';
import FormaPagoOtros from './FormModal/FormaPagoOtros';
import global from '../../../common/utility/global';

import Footer from './Footer';
import auth from '../../../common/utility/auth';

import dialog from "../../../common/utility/dialog";
import moment from "moment";
const InputGroup = Input.Group;
const { TabPane } = Tabs;

class ViewPago extends React.Component {


  constructor(props) {
    super(props);
  }


  handleOk = (e) => {
    debugger
    e.preventDefault();
    this.props.form.validateFieldsAndScroll((err, values) => {
      console.log(values);

      if (!err) {
        var data = null;

        if (this.props.formValues.listaComprobanteMasivo.length == 0) {
          data = this.fetchListaPago(values);
        } else {
          data = this.fetchReMasivo(values);
        }


        const validFormLogic = this.validateFormLogic(data, values);
        if (!validFormLogic) {
          return;
        } else {

          var dataNueva = [];

          data.forEach((key) => {

            dataNueva.push({
              idCuentasCobrar: this.props.formValues.idCuentasCobrar,
              idCuentasCobrarDetalle: this.props.formValues.idCuentasCobrarDetalle,
              idApertura: this.props.formValues.IdApertura,
              idCaja: this.props.formValues.IdCaja,
              tipoCambio: parseFloat(this.props.formValues.tipoCambio),
              parcial: this.props.formValues.flagPago,
              fecha: moment(key.fecha, "DD/MM/YYYY").format("DD/MM/YYYY"),
              idMetodoPago: key.idMetodoPago,
              idCuenta: key.idDestino,
              nroDocumento: key.nroDocumento == "" ? null : key.nroDocumento,
              idUsuarioRegistro: auth.user().id,
              idBanco: key.idBanco,
              idMoneda: key.idMoneda,
              nroOperacion: key.referencia == "" ? null : key.referencia,
              total: parseFloat(key.montoCuota),
              montoRecibido: parseFloat(key.montoRecibido),
              montoVuelto: parseFloat(key.montoVuelto),
            });
          });

          this.props.onSave(dataNueva, this.props.form);

        }

      }
    });
  };



  validateFormLogic = (data, values) => {

    var cantidadPago = data.length;
    var moneda = this.props.formValues.Moneda == "SOLES" ? 1 : 2;
    var tipoCambio = this.props.formValues.tipoCambio;

    var montoTotal = 0;

    if (cantidadPago === 0) {
      dialog.warning("Tiene que agregar los pagos");
      return false;
    }

    var montoSoles = data.filter(e => e.idMoneda == 1).reduce((a, b) => a + (b["montoCuota"] || 0), 0);
    var montoDolares = data.filter(e => e.idMoneda != 1).reduce((a, b) => a + (b["montoCuota"] || 0), 0);

    if (moneda == 1) {
      if (montoDolares == 0) {
        montoTotal = parseFloat(montoSoles.toFixed(2))

      } else {
        montoTotal = parseFloat(montoSoles + (montoDolares * tipoCambio))
        montoTotal = parseFloat(montoTotal.toFixed(2));
      }
    } else {

      montoTotal = parseFloat(montoDolares + (montoSoles / tipoCambio))
      montoTotal = parseFloat(montoTotal.toFixed(2));
    }

    if (!this.props.formValues.flagPago) {
      var saldoTotal = parseFloat(this.props.formValues.Saldo);
      var tolerancia = 0.05; // margen permitido, puedes ajustar este valor
      /*    if (parseFloat(montoTotal) != saldoTotal) {
           dialog.warning("El monto total ingresado, debe ser igual al saldo del pago.");
           return false;
         } */
      if (Math.abs(parseFloat(montoTotal) - saldoTotal) > tolerancia) {
        dialog.warning("El monto total ingresado debe ser igual al saldo del pago (con una tolerancia permitida).");
        return false;
      }
    } else {

      if (parseFloat(montoTotal) >= parseFloat(this.props.formValues.Saldo).toFixed(0)) {

        dialog.warning("El monto total ingresado, debe ser menor que el saldo del pago.");
        return false;
      }

    }


    return true;
  };


  fetchListaPago = (values) => {
    var result = [];
    var items = [];
    result = this.props.formValues.listaFormaPagoOtros.concat(this.props.formValues.listaFormaPago, this.props.formValues.listaFormaPagoCredito)

    var keys = [];
    var obj = Object.assign({}, values.arrMetodoPago);

    for (var [key] of Object.entries(obj)) {
      keys.push(key);
    }

    keys.forEach((key) => {
      items.push({
        identifier: key,
        total: parseFloat(values.arrMontoCuota[key]),
      });
    });


    const itemsMap = {};
    items.forEach(i => {
      itemsMap[i.identifier] = i.total;
    });

    const nuevoArray = result.map(item =>
      itemsMap[item.identifier] !== undefined
        ? { ...item, montoCuota: itemsMap[item.identifier] }
        : item
    );





    return nuevoArray;
  };

  fetchReferencias = (values) => {
    var result = [];

    var keys = [];
    var obj = Object.assign({}, values.arrMetodoPago);

    for (var [key] of Object.entries(obj)) {
      keys.push(key);
    }

    keys.forEach((key) => {
      var idCuenta = 0;
      if (values.arridDestino !== undefined) {
        //if(key==values.arridDestino[key])
        idCuenta = (values.arridDestino) == undefined ? 0 : ((values.arridDestino[key] == undefined ? 0 : values.arridDestino[key]));
        if (idCuenta != 0) {
          idCuenta = idCuenta.key;
        }
      }

      result.push({
        idCuentasCobrar: this.props.formValues.idCuentasCobrar,
        idCuentasCobrarDetalle: this.props.formValues.idCuentasCobrarDetalle,
        idApertura: this.props.formValues.IdApertura,
        idCaja: this.props.formValues.IdCaja,
        fecha: values.arrFecha[key].format("DD/MM/YYYY"),
        idMetodoPago: values.arrMetodoPago[key].key,
        idCuenta: idCuenta,
        idMoneda: values.arrMetodoPago[key].key,
        nroOperacion: (values.arrreferencia) == undefined ? "" : ((values.arrreferencia[key] == undefined ? "" : values.arrreferencia[key])),
        total: parseFloat(values.arrMontoCuota[key]),
      });
    });


    return result;
  };


  fetchReMasivo = (values) => {

    debugger
    var result = [];

    var keys = [];
    var obj = Object.assign({}, values.arrMetodoPago);

    for (var [key] of Object.entries(obj)) {
      keys.push(key);
    }
    keys.forEach((key, index) => {
      result.push({
        idCuentasCobrar: this.props.formValues.listaComprobanteMasivo[index].idCuentasCobrar,
        idCuentasCobrarDetalle: this.props.formValues.listaComprobanteMasivo[index].idCuentasCobrarDetalle,
        idCaja: this.props.formValues.listaComprobanteMasivo[index].IdCaja,
        idApertura: this.props.formValues.listaComprobanteMasivo[index].IdApertura,
        fecha: values.arrFecha[key].format("DD/MM/YYYY"),
        idMetodoPago: values.arrMetodoPago[key].key,
        idCuenta: values.arridDestino[key] == undefined ? 0 : values.arridDestino[key].key,
        nroOperacion: values.arrreferencia[key],
        total: parseFloat(values.arrMontoCuota[key]),
      });
    });


    return result;
  };


  handleOtrosPago = async (label, property, value, identifier, index) => {
    //var fecha = this.props.form.getFieldValue(`arrFecha[${identifier}]`);
    var metodoPago = this.props.form.getFieldValue(`arrMetodoPago[${identifier}]`);
    var banco = this.props.form.getFieldValue(`arrBanco[${identifier}]`);
    var referencia = this.props.form.getFieldValue(`arrreferencia[${identifier}]`);
    var montoCuota = this.props.form.getFieldValue(`arrMontoCuota[${identifier}]`);

    debugger
    var pagoOtros = this.props.formValues.listaFormaPagoOtros.filter(e => e.identifier != identifier);
    var formaPago = this.props.formValues.listaFormaPagoOtros.filter(e => e.identifier == identifier);

    var moneda = label.split("-")[0] == "PEN" ? 1 : 2;

    if (formaPago.length > 0) {

      var dataNueva = {
        identifier: global.fetchUniqueCode(),
        fecha: formaPago[0].fecha,
        idMetodoPago: metodoPago == undefined ? undefined : metodoPago.key,
        idDestino: value,
        nroDocumento: '',
        idBanco: banco == undefined ? undefined : banco.key,
        idMoneda: moneda,
        referencia: referencia,
        montoCuota: parseFloat(montoCuota),
        montoRecibido: formaPago[0].montoRecibido,
        montoVuelto: formaPago[0].montoVuelto
      };

      pagoOtros.splice(index, 0, dataNueva);

    }

    this.props.onOtrosPago(pagoOtros, this.props.form);


  }

  handleCancel = () => {
    this.props.onClose();
    this.props.form.resetFields();
  };


  render() {


    const { getFieldDecorator, setFieldsValue, getFieldValue } = this.props.form;

    getFieldDecorator("flagReferencia", {
      initialValue: false,
    });


    getFieldDecorator("listaFormaPagoOtros", {
      initialValue: this.props.formValues.listaFormaPagoOtros,
    });


    return (
      <Modal
        title={"Registrar Pago"}
        visible={this.props.visible}
        onCancel={this.handleCancel}
        style={{ top: 30 }}
        width={1200}
        footer={[
          <Button
            key="1"
            onClick={this.handleCancel}
          >
            Cancelar
          </Button>,
          <Button
            key="2"
            type="primary"
            onClick={this.handleOk}
          >
            Pagar
          </Button>
        ]}
      >
        <Form>


          <div className="row">
            <div className="col-md-3">
              <Form.Item label="Nro Documento">
                <Input readOnly
                  value={this.props.formValues.DocumentoCliente}
                />
              </Form.Item>
            </div>
            <div className="col-md-7">
              <Form.Item label="Cliente">
                <Input readOnly
                  value={this.props.formValues.RazonSocialClientemento}
                />
              </Form.Item>
            </div>

            <div className="col-md-2">
              <Form.Item label="Pago">
                {getFieldDecorator('flagPermisoCaja', {
                  initialValue: this.props.formValues.flagPago,
                  valuePropName: 'checked'
                })(
                  <Switch checkedChildren="Parcial" unCheckedChildren="Total"
                    disabled={this.props.formValues.flagDetraccion}
                    onChange={(option) => { this.props.onSwitch(option); }}

                  />
                )}
              </Form.Item>
            </div>
          </div>

          <div className="row">
            <div className="col-md-2" hidden={this.props.visibleDetalle}>
              <Form.Item label="Fecha Emisión">
                <Input readOnly
                  value={this.props.formValues.Fecha}
                  suffix={<Icon type="calendar" style={{ color: 'rgba(0,0,0,.25)' }} />}

                />
              </Form.Item>


            </div>
            <div className="col-md-2" hidden={this.props.visibleDetalle}>
              <Form.Item label="Tipo Cambio">
                <Input readOnly
                  value={this.props.formValues.tipoCambio}

                />
              </Form.Item>


            </div>
            <div className="col-md-2" hidden={this.props.visibleDetalle}>
              <Form.Item label="Nro Comprobante">
                <Input readOnly
                  value={this.props.formValues.nro_documento}
                />
              </Form.Item>
            </div>

            <div className="col-md-2" hidden={this.props.visibleDetalle}>
              <Form.Item label="Total Comprobante">
                <Input readOnly
                  value={this.props.formValues.Total.toFixed(2)}
                />
              </Form.Item>
            </div>

            <div className="col-md-2">
              <Form.Item label="Moneda Original">
                <Input readOnly
                  value={this.props.formValues.Moneda}
                />
              </Form.Item>
            </div>


          </div>

          <Divider>Detalle de Cobro</Divider>
          <div className="row">
            <div className="col-md-2" hidden={this.props.visibleDetalle}>
              <Form.Item label="Cuota">
                <Input readOnly
                  value={this.props.formValues.nroCouta}
                />
              </Form.Item>
            </div>
            <div className="col-md-3">
              <Form.Item label={this.props.formValues.Moneda.charAt(0) == "S" ? "Saldo a Cobrar S/" : "Saldo a Cobrar $"}>
                <Input readOnly
                  value={this.props.formValues.Saldo.toFixed(2)}
                />
              </Form.Item>
            </div>


            <div className="col-md-3">
              <Form.Item label={this.props.formValues.Moneda.charAt(0) == "D" ? "Monto al T.C. S/" : "Monto al T.C. $"}>
                <Input readOnly
                  value={this.props.formValues.Monto.toFixed(2)}
                />
              </Form.Item>
            </div>
            <div className="col-md-3">
              <Form.Item label="Forma Pago">
                <Input readOnly
                  value={this.props.formValues.formaPago}
                />
              </Form.Item>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12 form-group">

              <Tabs
                activeKey={this.props.formValues.activeKey}
                onChange={(key) => this.props.onChangeTab(key, setFieldsValue)}
                tabBarExtraContent={
                  <div className="custom-options">
                    <Button
                      icon="plus"
                      type="primary"
                      hidden={this.props.formValues.listaComprobanteMasivo.length > 0 ? true : false}
                      onClick={() =>
                        this.props.onAgregarDetalle(
                          this.props.form.setFieldsValue,
                          this.props.form.getFieldValue
                        )
                      }
                    >
                      Agregar
                    </Button>
                  </div>
                }
              >

                <TabPane tab="Mov. Bancos" key="3">
                  <FormaPagoOtros
                    dataSource={this.props.formValues.listaFormaPagoOtros}
                    onRemove={this.props.onRemoverFormaPago}
                    listaMetodoPago={this.props.formValues.listaMetodoPago}
                    listaMoneda={this.props.formValues.listaMoneda}
                    listaBanco={this.props.formValues.listaBanco}
                    listaCuentaDestino={this.props.formValues.listaCuentaDestino}
                    onGetFieldDecorator={getFieldDecorator}
                    isMasivo={this.props.visibleDetalle}
                    onChange={this.props.onChangePago}
                    onChangeCuenta={this.handleOtrosPago}
                  />
                </TabPane>
                <TabPane tab="Efectivo" key="1">
                  <FormaPagoEfectivo
                    dataSource={this.props.formValues.listaFormaPago}
                    onRemove={this.props.onRemoverFormaPago}
                    listaMetodoPago={this.props.formValues.listaMetodoPago}
                    listaMoneda={this.props.formValues.listaMoneda}
                    listaBanco={this.props.formValues.listaBanco}
                    listaCuentaDestino={this.props.formValues.listaCuentaDestino}
                    onGetFieldDecorator={getFieldDecorator}
                    isMasivo={this.props.visibleDetalle}
                    onChange={this.props.onChangePago}
                  />
                </TabPane>
                <TabPane tab="Nota de Crédito" key="2">
                  <FormaPagoCredito
                    dataSource={this.props.formValues.listaFormaPagoCredito}
                    onRemove={this.props.onRemoverFormaPago}
                    listaMetodoPago={this.props.formValues.listaMetodoPago}
                    listaMoneda={this.props.formValues.listaMoneda}
                    listaBanco={this.props.formValues.listaBanco}
                    listaCuentaDestino={this.props.formValues.listaCuentaDestino}
                    onGetFieldDecorator={getFieldDecorator}
                    isMasivo={this.props.visibleDetalle}
                    onChange={this.props.onChangePago}
                  />
                </TabPane>

              </Tabs>
            </div>
          </div>
          <Footer
            listaMetodoPago={this.props.formValues}

          />

        </Form>
      </Modal>
    );
  }
}

export default Form.create()(ViewPago);
